import { Box, ButtonProps, IconButton, Tooltip } from '@mui/material';
import IntroductionIcon from '@Components/Icons/IntroductionIcon';

const IntroductionButton = (props: ButtonProps) => {
  return (
    <Tooltip title="เพิ่มคำบรรยายส่วนต้น" arrow placement="top">
      <Box component={'span'}>
        <IconButton
          {...props}
          sx={{
            border: 1,
            borderRadius: 1,
            borderColor: 'secondary.lighter',
            padding: 1,
            width: '16px',
            height: '16px',
          }}
          color="inherit"
          size="small"
        >
          <IntroductionIcon fontSize="small" />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default IntroductionButton;
